import React from 'react';
import { useAuthSync } from '../../hooks/useAuthSync';

export const UserSync: React.FC = () => {
  useAuthSync();
  return null; // This component doesn't render anything
};
